<template>
  <div ref="scrollBarWapper" class="scrollBar-wapper">
      <slot></slot>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import MouseWheel from '@better-scroll/mouse-wheel';
import ScrollBar from '@better-scroll/scroll-bar';

export default {
  name: 'mbsScrollBar',
  props: {
    config: {
      type: Object,
      default() {
        return {
          scrollX: false,
          scrollY: true,
        };
      },
    },
    scrollbar: {
      type: Object,
      default() {
        return {
          interactive: true,
        };
      },
    },
    mouseWheel: {
      type: Object,
      default() {
        return {
          speed: 2,
          invert: false,
          easeTime: 300,
        };
      },
    },
  },
  mounted() {
    BScroll.use(ScrollBar);
    BScroll.use(MouseWheel);
    // eslint-disable-next-line no-new
    new BScroll(this.$refs.scrollBarWapper, {
      ...this.config,
      scrollbar: this.scrollbar,
      mouseWheel: this.mouseWheel,
    });
  },
};
</script>

<style lang="less">
.scrollBar-wapper {
    position: relative;
}
</style>
